module.exports = __webpack_public_path__ + "static/media/biotech.623ada2a.png";